import { ApiClientFactory } from '../ApiClientFactory';
import { API_URL } from '../Variables';

let clientFactory = new ApiClientFactory();

export const SupportClient = {
  createTicket(description) {
    return clientFactory.post(API_URL + 'support/ticket/create', description);
  },
};
